import useFetch from '../hooks/useFetch'
import { apiWrapper } from './dataHookUtils'

export default () => {
  const fetch = useFetch()

  const fetchClasses = async (accountId, implementationId) => {
    return apiWrapper({
      fetch,
      url: `accounts/classes?accountId=${accountId}&implementationId=${implementationId}`,
      options: {
        method: 'GET'
      }
    });
  }

  return {
    fetchClasses
  }
}